import { gql } from '@apollo/client';

/**
 * GraphQL mutation to delete a custom label
 */
export const DELETE_CUSTOM_LABEL = gql`
  mutation DeleteCustomLabel($communityId: ID!, $labelId: ID!) {
    deleteCustomLabel(communityId: $communityId, labelId: $labelId) {
      success
    }
  }
`;
